import { BackgroundCheckType } from '@/backend/features/background-check/types';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const useAccountDetailsFields = ({
    type,
}: {
    type: BackgroundCheckType;
}): {
    key: string;
    label: string;
    classifier?: string;
}[] => {
    const { t } = useTranslation();

    const standard = [
        {
            key: 'firstName',
            label: t('backgroundCheck.labels.firstName'),
        },
        {
            key: 'lastName',
            label: t('backgroundCheck.labels.lastName'),
        },
        {
            key: 'ssn',
            label: t('backgroundCheck.labels.ssn'),
        },
        {
            key: 'dateOfBirth',
            label: t('backgroundCheck.labels.dateOfBirth'),
        },
        {
            key: 'email',
            label: t('backgroundCheck.labels.email'),
        },
        {
            key: 'stateOfWork',
            label: t('backgroundCheck.labels.workState'),
        },
        {
            key: 'address.addressLine1',
            label: t('backgroundCheck.labels.addressLine1'),
        },
        {
            key: 'address.city',
            label: t('backgroundCheck.labels.city'),
        },
        {
            key: 'address.state',
            label: t('backgroundCheck.labels.state'),
        },
        {
            key: 'address.postalCode',
            label: t('backgroundCheck.labels.zip'),
        },
    ];

    const cori = [
        {
            key: 'firstName',
            label: t('backgroundCheck.labels.firstName'),
        },
        {
            key: 'lastName',
            label: t('backgroundCheck.labels.lastName'),
        },
        {
            key: 'dateOfBirth',
            label: t('backgroundCheck.labels.dateOfBirth'),
        },
        {
            key: 'address.addressLine1',
            label: t('backgroundCheck.labels.addressLine1'),
        },
        {
            key: 'address.city',
            label: t('backgroundCheck.labels.city'),
        },
        {
            key: 'address.state',
            label: t('backgroundCheck.labels.state'),
        },
        {
            key: 'address.postalCode',
            label: t('backgroundCheck.labels.zip'),
        },
        {
            key: 'genderId',
            label: t('backgroundCheck.labels.gender'),
            classifier: 'gender',
        },
    ];

    const jnet = [
        {
            key: 'firstName',
            label: t('backgroundCheck.labels.firstName'),
        },
        {
            key: 'lastName',
            label: t('backgroundCheck.labels.lastName'),
        },
        {
            key: 'dateOfBirth',
            label: t('backgroundCheck.labels.dateOfBirth'),
        },
        {
            key: 'ssn',
            label: t('backgroundCheck.labels.ssn'),
        },
    ];

    return React.useMemo(() => {
        switch (type) {
            case 'cori':
                return cori;
            case 'jnet':
                return jnet;
            default:
                return standard;
        }
    }, [t, type]);
};
